import React, { useState, useEffect } from "react";
import "./PremiumCookieBanner.css";
import { Link } from "react-router-dom";

export default function PremiumCookieBanner() {
  const [open, setOpen] = useState(false);
  const [toggles, setToggles] = useState({
    analytics: false,
    external: false,
  });

  useEffect(() => {
    const consent = localStorage.getItem("premiumCookieConsent");
    if (!consent) {
      setOpen(true);
    }
  }, []);

  const handleSave = () => {
    localStorage.setItem("premiumCookieConsent", JSON.stringify({
      essential: true,
      analytics: toggles.analytics,
      external: toggles.external
    }));
    setOpen(false);
  };

  const handleDecline = () => {
    localStorage.setItem("premiumCookieConsent", JSON.stringify({
      essential: true,
      analytics: false,
      external: false
    }));
    setOpen(false);
  };

  const handleAcceptAll = () => {
    localStorage.setItem("premiumCookieConsent", JSON.stringify({
      essential: true,
      analytics: true,
      external: true
    }));
    setOpen(false);
  };

  const toggle = (key: 'analytics' | 'external') => {
    setToggles(prev => ({ ...prev, [key]: !prev[key] }));
  };

  if (!open) return null;

  return (
    <div className="pcb-overlay">
      <div className="pcb-container">
        <div className="pcb-header">
          <h2>Privatsphäre-Einstellungen</h2>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="pcb-globe"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
        </div>
        
        <div className="pcb-content">
          <p>
            Auf unserer Webseite kommen Cookies zum Einsatz. Manche davon sind zwingend notwendig, während es uns andere ermöglichen, Ihre Nutzererfahrung auf unserer Webseite zu verbessern. Ihre Einwilligung erstreckt sich auch auf die Datenübermittlung an Anbieter in den USA. Wir weisen darauf hin, dass die USA derzeit kein mit der EU vergleichbares Datenschutzniveau haben und zudem das Risiko einer unentdeckten Datenverarbeitung durch staatliche Stellen besteht. Auf die dort vorgenommene Verarbeitung haben wir keinen Einfluss.
          </p>
          <p>
            Diese Zustimmung können Sie jederzeit in den Cookie-Einstellungen, in denen Sie auch weitere Details zu unseren Cookies finden, widerrufen oder ändern. Nähere Informationen zu Cookies finden Sie in unserer <Link to="/datenschutz">Datenschutzerklärung</Link>.
          </p>
          <p>Die Unternehmensdaten können Sie dem <Link to="/impressum">Impressum</Link> entnehmen.</p>
        </div>

        <div className="pcb-toggles">
          <label className="pcb-toggle-wrapper">
            <span>Essentiell</span>
            <div className="pcb-toggle pcb-toggle-disabled">
              <div className="pcb-toggle-thumb pcb-toggle-thumb-on">✔</div>
            </div>
          </label>
          
          <label className="pcb-toggle-wrapper" onClick={() => toggle('analytics')}>
            <span>Analyse/Performance</span>
            <div className={`pcb-toggle ${toggles.analytics ? 'pcb-toggle-active' : ''}`}>
              <div className={`pcb-toggle-thumb ${toggles.analytics ? 'pcb-toggle-thumb-on' : ''}`}>
                {toggles.analytics ? '✔' : '✖'}
              </div>
            </div>
          </label>

          <label className="pcb-toggle-wrapper" onClick={() => toggle('external')}>
            <span>Externe Medien</span>
            <div className={`pcb-toggle ${toggles.external ? 'pcb-toggle-active' : ''}`}>
              <div className={`pcb-toggle-thumb ${toggles.external ? 'pcb-toggle-thumb-on' : ''}`}>
                {toggles.external ? '✔' : '✖'}
              </div>
            </div>
          </label>
        </div>

        <div className="pcb-actions">
          <button className="pcb-btn pcb-btn-secondary" onClick={handleSave}>Speichern</button>
          <button className="pcb-btn pcb-btn-secondary" onClick={handleDecline}>Ablehnen</button>
          <button className="pcb-btn pcb-btn-primary" onClick={handleAcceptAll}>Alles akzeptieren</button>
        </div>

        <div className="pcb-footer">
          <div className="pcb-footer-links">
            <Link to="/datenschutz">Datenschutzerklärung</Link>
            <Link to="/impressum">Impressum</Link>
            <span style={{cursor:'pointer', textDecoration:'underline'}}>Einstellungen</span>
          </div>
          <div className="pcb-footer-brand">
            Powered by Usercentrics Consent Management
          </div>
        </div>
      </div>
    </div>
  );
}
